import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const INTERESTS = ["Honda", "Proton", "Jaecoo", "Omoda", "Undecided"];

export default function EnquiryForm({ type = "general", dark = false, extra = [], submitLabel = "Send Enquiry", testid = "enquiry" }) {
  const [form, setForm] = useState({ name: "", phone: "", interest: INTERESTS[0], message: "" });
  const [extras, setExtras] = useState({});
  const [busy, setBusy] = useState(false);

  const inputCls = `w-full border px-4 py-3.5 text-sm outline-none transition-colors placeholder:text-neutral-400 ${
    dark
      ? "border-white/20 bg-transparent text-white focus:border-white"
      : "border-black/20 bg-white text-black focus:border-black"
  }`;
  const labelCls = `mb-2 block font-mono text-[9px] uppercase tracking-[0.25em] ${dark ? "text-neutral-400" : "text-neutral-500"}`;

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Please fill in your name and phone number.");
      return;
    }
    setBusy(true);
    try {
      const extraMsg = extra.map((x) => `${x.label}: ${extras[x.name] || "-"}`).join("\n");
      await api.enquire({
        type,
        name: form.name.trim(),
        phone: form.phone.trim(),
        interest: form.interest,
        message: [extraMsg, form.message].filter(Boolean).join("\n"),
      });
      toast.success("Received! We'll WhatsApp you shortly.");
      setForm({ name: "", phone: "", interest: INTERESTS[0], message: "" });
      setExtras({});
    } catch {
      toast.error("Something went wrong. Please try WhatsApp instead.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testid}-form`} className="space-y-5">
      <div className="grid gap-5 sm:grid-cols-2">
        <div>
          <label className={labelCls}>Name *</label>
          <input data-testid={`${testid}-name`} className={inputCls} placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </div>
        <div>
          <label className={labelCls}>Phone / WhatsApp *</label>
          <input data-testid={`${testid}-phone`} className={inputCls} placeholder="01X-XXXXXXX" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
        </div>
      </div>
      <div>
        <label className={labelCls}>Brand of Interest</label>
        <select data-testid={`${testid}-interest`} className={inputCls} value={form.interest} onChange={(e) => setForm({ ...form, interest: e.target.value })}>
          {INTERESTS.map((i) => <option key={i} className="text-black">{i}</option>)}
        </select>
      </div>
      {extra.map((x) => (
        <div key={x.name}>
          <label className={labelCls}>{x.label}</label>
          <input data-testid={`${testid}-${x.name}`} className={inputCls} placeholder={x.placeholder || ""} value={extras[x.name] || ""} onChange={(e) => setExtras({ ...extras, [x.name]: e.target.value })} />
        </div>
      ))}
      <div>
        <label className={labelCls}>Message</label>
        <textarea data-testid={`${testid}-message`} rows={3} className={inputCls} placeholder="Anything we should know?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
      </div>
      <button
        type="submit"
        disabled={busy}
        data-testid={`${testid}-submit`}
        className={`w-full py-4 font-mono text-[11px] uppercase tracking-[0.25em] transition-colors disabled:opacity-50 ${
          dark ? "bg-white text-black hover:bg-neutral-200" : "bg-black text-white hover:bg-neutral-800"
        }`}
      >
        {busy ? "Sending…" : submitLabel}
      </button>
    </form>
  );
}
